import { useState } from 'react';
import { useApiQuery } from '@/hooks/useApi';
import { getUserProfile } from '@/services';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';

export const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  
  const { data: user, isLoading, error } = useApiQuery({
    queryKey: ['user', 'profile'],
    queryFn: getUserProfile,
  });
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
            <p className="mt-2 text-gray-600">加载中...</p>
          </div>
        </div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center py-12">
            <p className="text-red-600">加载失败: {error}</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-900">个人资料</h1>
            <Button
              onClick={() => setIsEditing(!isEditing)}
              className={isEditing ? "btn-secondary" : "btn-primary"}
            >
              {isEditing ? '取消' : '编辑'}
            </Button>
          </div>
          
          <Card>
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center mb-6">
                <div className="h-20 w-20 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-2xl font-medium text-primary-600">
                    {user?.name?.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div className="ml-6">
                  <h2 className="text-xl font-semibold text-gray-900">{user?.name}</h2>
                  <p className="text-sm text-gray-500">{user?.email}</p>
                </div>
              </div>
              
              <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
                <div>
                  <dt className="text-sm font-medium text-gray-500">用户ID</dt>
                  <dd className="mt-1 text-sm text-gray-900">{user?.id || '-'}</dd>
                </div>
                
                <div>
                  <dt className="text-sm font-medium text-gray-500">用户角色</dt>
                  <dd className="mt-1">
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                      user?.role === 'admin' 
                        ? 'bg-purple-100 text-purple-800' 
                        : 'bg-blue-100 text-blue-800'
                    }`}>
                      {user?.role === 'admin' ? '管理员' : '普通用户'}
                    </span>
                  </dd>
                </div>
                
                <div>
                  <dt className="text-sm font-medium text-gray-500">注册时间</dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {user?.createdAt ? new Date(user.createdAt).toLocaleDateString() : '-'}
                  </dd>
                </div>
                
                <div>
                  <dt className="text-sm font-medium text-gray-500">最后更新</dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {user?.updatedAt ? new Date(user.updatedAt).toLocaleDateString() : '-'}
                  </dd>
                </div>
              </dl>
              
              {isEditing && (
                <div className="mt-6 pt-6 border-t border-gray-200">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">编辑资料</h3>
                  <p className="text-sm text-gray-600">编辑功能正在开发中...</p>
                </div>
              )}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};